export enum TaxationType {
  GENERAL = 'Загальна',
  SIMPLIFIED_1 = 'Спрощена 1 група',
  SIMPLIFIED_2 = 'Спрощена 2 група',
  SIMPLIFIED_3 = 'Спрощена 3 група',
  SIMPLIFIED_4 = 'Спрощена 4 група'
}

export interface CreateOrgDto {
  readonly name: string;
  readonly fullName?: string;
  readonly shipmentSignatoryName?: string | null;
  readonly shipmentSignatoryPosition?: string | null;
  readonly edrpou?: string;
  readonly ipn?: string;
  readonly taxationType?: TaxationType;
  readonly legalAddress?: string;
  readonly actualAddress?: string;
  readonly phone?: string;
  readonly email?: string;
  readonly director_id?: number | null;
  readonly accountant_id?: number | null;
  readonly isActive?: boolean;

  // Deprecated legacy organization bank fields (do not use in org UI)
  readonly bankAccount?: string;
  readonly bankName?: string;
  readonly mfo?: string;
}

export interface UpdateOrgDto {
  readonly id: number;
  readonly name?: string;
  readonly fullName?: string;
  readonly shipmentSignatoryName?: string | null;
  readonly shipmentSignatoryPosition?: string | null;
  readonly edrpou?: string;
  readonly ipn?: string;
  readonly taxationType?: TaxationType;
  readonly legalAddress?: string;
  readonly actualAddress?: string;
  readonly phone?: string;
  readonly email?: string;
  readonly director_id?: number | null;
  readonly accountant_id?: number | null;
  readonly isActive?: boolean;

  // Deprecated legacy organization bank fields (do not use in org UI)
  readonly bankAccount?: string;
  readonly bankName?: string;
  readonly mfo?: string;
}

export interface SearchOrgDto {
  readonly id?: number;
  readonly name?: string;
  readonly edrpou?: string;
  readonly ipn?: string;
  readonly taxationType?: TaxationType;
  readonly isActive?: boolean;
  readonly limit?: number;
  readonly offset?: number;
}

export interface OrgBankAccount {
  readonly id: number;
  readonly iban: string;
  readonly bankName?: string;
  readonly accountName?: string;
  readonly isPrimary: boolean;
  readonly isActive: boolean;
  readonly organization?: {
    readonly id: number;
    readonly name: string;
  };
}

export interface CreateOrgBankAccountDto {
  readonly org_id: number;
  readonly iban: string;
  readonly bankName?: string;
  readonly accountName?: string;
  readonly isPrimary?: boolean;
  readonly isActive?: boolean;
}

export interface UpdateOrgBankAccountDto {
  readonly id: number;
  readonly org_id?: number;
  readonly iban?: string;
  readonly bankName?: string;
  readonly accountName?: string;
  readonly isPrimary?: boolean;
  readonly isActive?: boolean;
}
